/**
 * Modelo de documento de ayuda con secciones opcionales (menú lateral).
 */

export type HelpDocumentMode = 'legacy' | 'sections';

export const HELP_DOCUMENT_VERSION = 'v1';
export const HELP_SECTION_PRINCIPAL_ID = 'principal';

export interface HelpSection {
  id: string;
  /** Clave i18n del menú lateral (ej. modo-mapa); se muestra con | translate */
  title: string;
  content: string;
  order: number;
}

export interface HelpDocument {
  mode: HelpDocumentMode;
  sections: HelpSection[];
  /** HTML completo cuando mode === 'legacy' */
  legacyHtml?: string;
}

export type HelpSectionsByLang = Record<string, HelpSection[]>;
